__turbopack_context__.v({
  "acessibilidadeNum": "rJtVpW_acessibilidadeNum",
  "acessibilidadeTopo": "rJtVpW_acessibilidadeTopo",
  "containerFlex": "rJtVpW_containerFlex",
  "lineContrast": "rJtVpW_lineContrast",
  "linkAcessibilidade": "rJtVpW_linkAcessibilidade",
  "linkAcessibilidadeSize": "rJtVpW_linkAcessibilidadeSize",
  "listMenuAcessibilidade": "rJtVpW_listMenuAcessibilidade",
  "uiContainer": "rJtVpW_uiContainer",
});
